import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/OverflowMenu/overflow-menu';
import { OverflowMenuContext } from './OverflowMenuContext';
export var OverflowMenuGroup = function OverflowMenuGroup(_ref) {
  var className = _ref.className,
      children = _ref.children,
      _ref$isPersistent = _ref.isPersistent,
      isPersistent = _ref$isPersistent === void 0 ? false : _ref$isPersistent,
      groupType = _ref.groupType;
  return React.createElement(OverflowMenuContext.Consumer, null, function (value) {
    return (isPersistent || !value.isBelowBreakpoint) && React.createElement("div", {
      className: css(styles.overflowMenuGroup, groupType === 'button' && styles.modifiers.buttonGroup, groupType === 'icon' && styles.modifiers.iconButtonGroup, className)
    }, children);
  });
};